import register from '../../../../global/js/registry';
export default register('o-download-list', () => import(/* webpackMode: "lazy" */ './o-download-list.controller'));
